export const PROFILE_INFO = {
    logo: 'Arvind.p',
    displayName: 'Arvind Padala',
    role: 'AI Systems Engineer',
    slogan: 'Building AI that ships. Intelligence, engineered.',
    email: 'padalaarvindchary@gmail.com',
    about: `
I build **intelligent systems** from the ground up.

My work blends **machine learning**, **data engineering**, and **product thinking** to turn raw data into scalable AI applications. I’ve developed **anomaly detection engines**, **forecasting systems**, and **semantic recommendation models** designed to move beyond notebooks into production.

I’m driven by one idea: **AI** shouldn’t just generate outputs, it should **power systems** that operate.

Always **learning**, always **experimenting**, always pushing the boundaries of what's possible with data.
`,
    resumeUrl: '/Arvind_Padala_Resume.pdf',
    profileImage: '/Arvind_Profile.jpg',
} as const;
